import script from "./match.vue?vue&type=script&setup=true&name=Match&lang=js"
export * from "./match.vue?vue&type=script&setup=true&name=Match&lang=js"

import "./match.vue?vue&type=style&index=0&id=6f0c1203&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0c1203"]])

export default __exports__